<template>
  <div class="train-container">
    <div class="courseList">
      <div v-for="(item, index) in courseList"
          :key="item.id"
          class="course box-shadow"
          :class="index%4!==0? 'course-margin' :''">
        <div class="course-img"
            @click="goCourseDetail(item.id)">
          <img :src="item.logoUrl || item.url || imgUrl"
              :alt="item.name"
              width="283px"
              height="160px" />
        </div>
        <div class="course-name overell"
            @click="goCourseDetail(item.id)">{{item.courseName}}</div>
        <div class="course-info">
          <div>{{item.salesVolumes || 0}}人购买&nbsp;| &nbsp;{{item.viewCount || 0}}浏览</div>
          <div>
            <span class="course-info-price">{{item.currentPrice && Number(item.currentPrice) > 0 ? ( '￥' + item.currentPrice) : '免费'}}</span>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      class="s2b_page"
      style="text-align: center;"
      :current-page="page"
      :page-size="limit"
      :total="total"
      prev-text="上一页"
      next-text="上一页"
      layout="prev, pager, next, total, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
      <!-- :page-sizes="[10, 20, 50, 100]" -->
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgUrl: require('@/assets/img/占位图.png')
    }
  },
  props: {
    courseList: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 12
    }
  },
  methods: {
    goCourseDetail (id) {
      // 浏览次数加一
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`, {
        type: 2, // type --1:新闻/2：课程/3：图书/4：问答
        id: id
      })
      this.$router.push({ name: 'courseDetail', query: { id: id } })
    },
    // 改变页面显示条数
    pageSizeChangeHandle () {},
    // 更改当前页
    pageCurrentChangeHandle (val) {
      this.$emit('changePage', val)
    }
  }
}
</script>
<style scoped>
.train-container {
  width: 1190px;
  /* padding: 0 20px; */
  margin: 0 auto;
}
.courseList {
  /* border: 1px solid #000; */
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-between; */
  align-content: flex-start;
}
.course {
  width: 283px;
  /* height: 149px; */
  /* border: 1px solid #000; */
  margin: 0 0 50px 0;
  overflow: hidden;
  background: #fff;
}
.course-margin {
  margin-left: 19px;
}
.course-img {
  cursor: pointer;
  width: 283px;
  height: 160px;
}
.course-name {
  margin-top: 10px;
  padding-left: 12px;
  /* height: 22px; */
  line-height: 22px;
  font-size: 16px;
  color: #262626;
  cursor: pointer;
  user-select: none;
}
.course-name:hover {
  color: #1d65a8;
}
.course-info {
  padding: 0 5px 10px 12px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.course-info-price {
  padding: 1px 12px;
  text-align: center;
  font-size: 22px;
  color: #ff3116;
}
</style>
